import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "../css/Niveles.css";

// Línea general del colegio. Mientras quede vacía, el botón aparece únicamente
// en las páginas que tienen su propia línea (ver NUMEROS_POR_RUTA). Al cargarla,
// el botón pasa a mostrarse en todo el sitio automáticamente.
const NUMERO_GENERAL = "";

// Formato internacional sin signos: 54 + 9 + código de área sin 0 + número.
const NUMEROS_POR_RUTA = {
  "/inicial": "543515075361",
  "/nocturno": "543516317715",
};

const MENSAJE = "Hola, estoy visitando la página, necesito información.";

export default function BotonWhatsapp() {
  const { pathname } = useLocation();
  const [mostrarTexto, setMostrarTexto] = useState(true);

  const numero = NUMEROS_POR_RUTA[pathname.toLowerCase()] || NUMERO_GENERAL;

  // El cartelito "Escribinos" se muestra unos segundos y se esconde. Antes esto
  // se hacía con un setTimeout suelto que tocaba el DOM por id y quedaba vivo
  // después de cambiar de página.
  useEffect(() => {
    setMostrarTexto(true);
    const temporizador = setTimeout(() => setMostrarTexto(false), 7000);
    return () => clearTimeout(temporizador);
  }, [pathname]);

  if (!numero) return null;

  return (
    <a
      href={`https://wa.me/${numero}?text=${encodeURIComponent(MENSAJE)}`}
      className="whatsapp"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Escribinos por WhatsApp"
    >
      {mostrarTexto && <p className="text-wp">Escribinos</p>}
      <i className="fa fa-whatsapp whatsapp-icon"></i>
    </a>
  );
}
